<template>
	<div class="report_container full" v-loading="loading">
		<vxe-grid v-if="list_gridOptions" ref="flowcheckerrorreport" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>		
		<checkerror-index ref="batchcheckerror" :checkerrordata="checkerrordata" @positioning="positioning" />
	</div>
</template>
<style>

</style>
<style scoped>
	.head {
		padding: 10px 0;
		border-bottom: 1px solid rgb(220, 223, 230);
	}

	.aside {
		border-right: 1px solid rgb(220, 223, 230);
		box-sizing: border-box;
		padding-bottom: 100px;
	}

	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;

	}

	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;

	}
</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import checkerrorIndex from './lib/checkerror/index.vue'
	export default {
		mixins: [listMixins],
		name: 'report',
		props: {
			fundtype: {
				default: () => {
					return 'CD'
				}
			},
		},
		data() {
			return {
				loading:false,
				currentrow:{},
				checkerrordata:[],
				reportName: 'reconciliation_bankflow',
				resdata:[],
				list_formConfig: [{
					field: 'transTime',
					title: '月份',
					span: 8,
					itemRender: {
						props:{
							type:'month'
						},
						name: '$datePicker'
					}
				}],
				list_footerField:[
					{field:'errorcount',toFixed:2}
				]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			list_init() {
				this.loading = true
				this.$api.bankaccount.list({
					type: 'wln'
				}).then((res) => {
					this.loading = false
					let group = this.$Lodash.groupBy(res.list, 'acc_code')
					let wlnbankoptions = []
					//console.log(group)
					for (let i in group) {
						let inst_account = group[i].map((item)=>{
							return item.inst_account
						})
						group[i][0].inst_account = inst_account.join(',')
						wlnbankoptions.push(group[i][0])
					}
					this.wlnbankoptions = wlnbankoptions.map((item) => {
						return {
							value: item.acc_code.toString(),
							label: item.acc_name,
							acc_uid: item.acc_uid,
							inst_account: item.inst_account
						}
					})
					this.init_formButton()
					let list_gridOptions = this.list_getOption()
					this.list_beforeCreateGrid(list_gridOptions)
					this.list_gridOptions = list_gridOptions

				},()=>{
					this.loading = false
				})

			},
			init_formButton() {

			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.id = 'checkerrorreport_list'
				gridOptions.height = 850
				gridOptions.pagerConfig = {
					enabled: true,
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 1000,
					pageSizes: [10, 20, 50, 2000, 5000],
				}
				gridOptions.toolbarConfig.buttons = [{
					name: '开始核对',
					status: 'success',
					code: 'begincheck'
				}]
				gridOptions.columns = [{
						field: 'accName',
						title: '户名',
						render: '',
						props: {
							show: true,
						}
					},
					{
						field: 'bankAcc',
						title: '账号',
						render: '',
						props: {
							show: true
						}
					},
					{
						field: 'errorcount',
						title: '差异数量',
						render: '',
						props: {
							show: true
						}
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({row}) => {
								return [<el-button type = "text" size = "mini" onClick = {() => {this.detail(row)}}>详情</el-button>]
							}
						}
					}
				]

				gridOptions.pagerConfig.enabled = false
			},
			begincheck() {
				let form = this.$refs.flowcheckerrorreport.getProxyInfo().form
				if(!form.transTime){
					this.$message.error('请选择月份')
					return
				}
				let transTime = [
					parseInt(this.$Moment(form.transTime).startOf('month').valueOf()/1000),
					parseInt(this.$Moment(form.transTime).endOf('month').valueOf()/1000)
				]
				this.loading = true
				this.resdata = []
				this.wlnbankoptions.forEach((item)=>{
					let bank = item
					if (bank.value && bank.inst_account) {
						this.getdata(transTime,bank)
					}
				})
				// console.log(this.wlnbankoptions)
			},
			getdata(transTime,bank) {
				this.$api.report.reportlist(this.reportName, {
					pageSize: 10000,
					currentPage: 1,
					transTime: transTime.join(','),
					cdSign: -1,
					fundtype: 'CHECK',
					wlnbank:bank.value,
					wlnbankaccount:bank.inst_account,
				}).then((res) => {
					if(res.list && res.list.length){
						this.checkerror(bank,res.list)
					}
					//console.log(res)
				}, () => {

				})
			},
			list() {
				return new Promise(resolve => {
					let data = []
					resolve(data)
				})
			},
			detail(row){
				console.log(row)
				this.currentrow = row
				this.checkerrordata = row.data
				this.$nextTick(()=>{
					this.$refs.batchcheckerror.modal_show()
				})
			},
			positioning(e){
				this.$emit('changetab',{
					node:'CHECK',
					query:{
						id:e.data,
						transTime:null,
						wlnbank:this.currentrow.bank.value,
						wlnbankaccount:this.currentrow.bank.inst_account,
					}
				})
			},
			checkerror(bank,data) {
				data = data.map((item) => {
					return {
						id: item.id,
						serialNo: item.serialNo?item.serialNo.trim():null,
						amount: item.amount,
						export_jindie_type: item.export_jindie_type,
						export_jindie_sucess: item.export_jindie_sucess
					}
				})
				let grouptype = this.$Lodash.groupBy(data, 'export_jindie_type')
				for (let i in grouptype) {
					let newarr = []
					let groupserialNo = this.$Lodash.groupBy(grouptype[i], 'serialNo')
					for (let j in groupserialNo) {
						let obj = groupserialNo[j][0]
						obj.amount = this.$Lodash.sumBy(groupserialNo[j], (item) => {
							return parseFloat(item.amount)
						})
						obj.id = groupserialNo[j].map((iditem) => {
							return iditem.id
						})
						obj.id = obj.id.join(',')
						obj.amount = Math.abs(obj.amount)
						newarr.push(obj)
					}
					grouptype[i] = newarr
				}
				this.$api.reconciliation_bankflow.checkerror({
					data: grouptype,
				}).then((res) => {
					let data = res.filter((item) => {
						return item.res != 1
					})
					if (data.length) {
						this.resdata.push({
							id:bank.value,
							accName:bank.label,
							bankAcc:bank.inst_account,
							errorcount:data.length,
							bank:bank,
							data:data,
						})
						this.loading = true
						this.$refs.flowcheckerrorreport.reloadData(this.resdata).then(()=>{
							this.loading = false
						})
					}
					
				}, () => {
					this.loading = false
				})

			},
			customreload(){
				
			}
		},
		components: {
			checkerrorIndex
			// editIndex
		}
	}
</script>